import { ShieldCheck } from '@orgus/ui/icons';
import TrustSettings from '../../trust/TrustSettings.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'trust',
  title: 'Trust and kill switches',
  description: 'Machine keys, signed commands, the audit chain and kill switches.',
  order: 10,
  group: 'security',
  keywords: ['kill switch', 'stop everything', 'machine keys', 'signing', 'audit chain', 'trust'],
  icon: ShieldCheck,
  Component: TrustSettings,
};
export default section;
